import {connect} from 'react-redux';
import Preview from '../components/PreviewDialog';
import {loadCredentials} from "../../credentials/actions";
import {mapPreviewToProps} from '../selectors';

export default connect(mapPreviewToProps, {loadCredentials})(Preview);
